<template>
  <el-select ref="services" v-model="selected" clearable filterable :disabled="disabled ? true : false"
    :placeholder="$t('selecione-uma-opcao')" :multiple="multiple" @change="update()">
    <el-option v-for="row of services" :key="row.id" :label="`${row.name} (${row.code})`" :value="row.id"></el-option>
  </el-select>
</template>

<script>
import { ServicesService } from "@/services/customers/services.services";
export default {
  name: "ServicesList",
  data: function () {
    return {
      services: [],
      selected: "",
    };
  },
  watch: {
    current(newVal, oldVal) {
      this.selected = newVal;
    }
  },
  props: {
    current: String,
    disabled: Boolean,
    multiple: false,
  },
  methods: {
    fetchServices() {
      const vm = this;
      ServicesService.actives()
        .then((response) => {
          vm.services = response.records;
          setTimeout(() => {
            if (vm.$props.current) {
              vm.selected = vm.$props.current;
            }
          }, 500);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchServices();
  },
};
</script>